function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* eslint-disable react/jsx-props-no-spreading */
import PropTypes from 'prop-types';
import React from 'react';
import Error from '@components/common/form/fields/Error';
import '../Field.scss';
var inputProps = function buidProps(props) {
  var obj = {};
  ['autocomplete', 'autofocus', 'dirname', 'disabled', 'form', 'maxlength', 'minlength', 'name', 'pattern', 'placeholder', 'readonly', 'onChange', 'onFocus', 'onBlur', 'onKeyPress', 'onKeyDown', 'onKeyUp', 'value', 'id'].forEach(a => {
    if (props[a]) obj[a] = props[a];
    obj.defaultValue = props.value;
  });
  return obj;
};
var Input = /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
    label,
    name,
    instruction,
    prefix,
    suffix,
    error,
    className
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: "  form-field-container ".concat(error ? 'has-error' : null)
  }, label && /*#__PURE__*/React.createElement("label", {
    htmlFor: name
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "field-wrapper flex flex-grow"
  }, prefix && /*#__PURE__*/React.createElement("div", {
    className: "field-prefix align-middle"
  }, prefix), /*#__PURE__*/React.createElement("input", _extends({
    className: className || 'text-[#000]',
    type: "text"
  }, inputProps(props), {
    ref: ref
  })), /*#__PURE__*/React.createElement("div", {
    className: "field-border"
  }), suffix && /*#__PURE__*/React.createElement("div", {
    className: "field-suffix"
  }, suffix)), instruction && /*#__PURE__*/React.createElement("div", {
    className: "field-instruction mt-sm"
  }, instruction), /*#__PURE__*/React.createElement(Error, {
    error: error
  }));
});
Input.propTypes = {
  error: PropTypes.string,
  instruction: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  name: PropTypes.string,
  className: PropTypes.string,
  prefix: PropTypes.node,
  suffix: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Input.defaultProps = {
  error: undefined,
  instruction: undefined,
  label: undefined,
  className: undefined,
  prefix: undefined,
  suffix: undefined,
  name: undefined,
  value: undefined
};
export { Input };